import React from "react";
import MainRouter from "./MainRouter";

function App() {
  return <MainRouter />;
}

export default App;
